import { InfoPageListItem } from './InfoPageListItem.style';

export default InfoPageListItem;
